import { object } from 'prop-types';
import {
    FETCH_LAYERS_REQUEST,
    FETCH_LAYERS_FAILURE,
    FETCH_LAYERS_SUCCESS,
    FETCH_LAYER_REQUEST,
    FETCH_LAYER_SUCCESS,
    FETCH_LAYER_FAILURE,
    SET_BASE_LAYER
} from './Types';
import { IBaseLayer, ILayer, ILayerAction, ILayerReducerState } from './layerTypes';

const defaultState = {
    isFetchingLayers: true,
    isFetchingLayer: true,
    layers: [],
    baseLayers: [],
    activeLayers: [],
    searchLayers: object,
    baseLayer: 'aerial'
};

function setBaseLayer(baseLayers: IBaseLayer[], baseLayer: string): string {
    // If value is a string (system_name) then try and convert to the base layer object
    if (typeof baseLayer === 'string') {
        baseLayer = (baseLayers.find(
            (e: { system_name: string }) => e.system_name === baseLayer
        ) || baseLayer) as string;
    }
    return baseLayer;
}

function updateLayerProperty(
    layers: ILayer[],
    systemName: string,
    updateFunc: (x: any) => any
): ILayer[] {
    const updatedLayers = [...layers];
    const idx = updatedLayers.findIndex(
        (e: { system_name: string }) => e.system_name === systemName
    );
    const updatedLayer = { ...updatedLayers[idx] };
    updatedLayers[idx] = updateFunc(updatedLayer);
    return updatedLayers;
}

export default function reducer(
    state = defaultState,
    action: ILayerAction
): ILayerReducerState {
    switch (action.type) {
        case FETCH_LAYERS_REQUEST:
            return {
                ...state,
                isFetchingLayers: true
            };
        case FETCH_LAYERS_SUCCESS:
            return {
                ...state,
                layers: action.layers,
                baseLayer: setBaseLayer(action.baseLayers, state.baseLayer),
                baseLayers: action.baseLayers,
                searchLayers: action.searchLayers,
                isFetchingLayers: false
            };
        case FETCH_LAYERS_FAILURE:
            return {
                ...state,
                error: {
                    status: action?.error?.status,
                    statusText: action?.error?.statusText
                },
                isFetchingLayers: false
            };
        case FETCH_LAYER_REQUEST:
            return {
                ...state,
                isFetchingLayer: true
            };
        case FETCH_LAYER_SUCCESS:
            return {
                ...state,
                layers: replaceLayer(state, action),
                isFetchingLayer: false
            };
        case FETCH_LAYER_FAILURE:
            return {
                ...state,
                error: {
                    status: action?.error?.status,
                    statusText: action?.error?.statusText
                },
                isFetchingLayer: false
            };
        case SET_BASE_LAYER:
            return {
                ...state,
                baseLayer: setBaseLayer(state.baseLayers, action.baseLayer)
            };
        default:
            return state;
    }
}

function replaceLayer(state: ILayerReducerState, action: ILayerAction) {
    const idx = state.layers.findIndex(layer => layer.id === action.layer.id);
    if (idx !== -1) {
        const layers = [...state.layers];
        layers[idx] = action.layer;
        return layers;
    }
    return state.layers;
}
